var _toConsumableArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/defineProperty");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

module.exports = function (e) {
  var t = {};

  function n(a) {
    if (t[a]) return t[a].exports;
    var r = t[a] = {
      i: a,
      l: !1,
      exports: {}
    };
    return e[a].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, a) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: a
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var a = Object.create(null);
    if (n.r(a), Object.defineProperty(a, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      n.d(a, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return a;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 65);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  4: function _(e, t) {
    e.exports = require("../../utils/utils");
  },
  65: function _(e, t, n) {
    "use strict";

    var a = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    },
        r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = a(n(1)),
        l = a(n(2)),
        s = n(66),
        c = r(n(67)),
        i = n(4),
        u = l.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n\n  &.focused {\n    .Optioner-box-container {\n      ", ";\n    }\n  }\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
      var e = _ref.theme;
      return e.wrapper;
    }, function (_ref2) {
      var e = _ref2.theme;
      return e.boxContainerFocused;
    }, function (_ref3) {
      var e = _ref3.theme,
          t = _ref3.totalItems,
          n = _ref3.selectedItemIndex;
      return e.dynamicTheme && e.dynamicTheme(t, n);
    }, function (_ref4) {
      var e = _ref4.disabled;
      return e && "\n    opacity: 0.4;\n    pointer-events: none;\n  ";
    }),
        d = l.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref5) {
      var e = _ref5.theme;
      return e.checkboxGroup;
    }),
        f = l.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref6) {
      var e = _ref6.theme;
      return e.boxContainer;
    }),
        p = l.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: none;\n  ", ";\n\n  ", "\n"])), function (_ref7) {
      var e = _ref7.theme;
      return e.inputHeader;
    }, function (_ref8) {
      var e = _ref8.show;
      return e && l.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: block;\n  "])));
    }),
        m = l.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref9) {
      var e = _ref9.theme;
      return e.content;
    }),
        b = l.default.label(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  input {\n    ", ";\n  }\n\n  ", ";\n"])), function (_ref10) {
      var e = _ref10.theme;
      return e.box;
    }, function (_ref11) {
      var e = _ref11.theme,
          t = _ref11.index,
          n = _ref11.selected;
      return e.boxIndex && e.boxIndex(t, n);
    }, function (_ref12) {
      var e = _ref12.theme;
      return e.input;
    }, function (e) {
      return e.selected && l.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      ", ";\n    "])), function (_ref13) {
        var e = _ref13.theme;
        return e.selected;
      });
    }),
        h = l.default.label(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  font-weight: 400;\n  text-transform: uppercase;\n  letter-spacing: 3.7px;\n\n  margin: 0;\n  margin-bottom: 10px;\n\n  ", ";\n"])), function (_ref14) {
      var e = _ref14.theme;
      return e.label;
    }),
        x = l.default.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref15) {
      var e = _ref15.theme;
      return e.text;
    }),
        g = l.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref16) {
      var e = _ref16.theme;
      return e.textContainer;
    }),
        v = l.default.span(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref17) {
      var e = _ref17.theme;
      return e.error;
    });

    function y(e, t, n) {
      if (n) switch (t) {
        case "single":
          return e.map(function (e) {
            return e.selected && e.value;
          }).filter(function (e) {
            return 0 === e || e;
          });

        case "object":
          return e.map(function (e) {
            return e.selected && e;
          }).filter(function (e) {
            return e;
          });

        case "list":
          return e.map(function (e) {
            return e;
          });

        default:
          return "Items not found";
      } else switch (t) {
        case "single":
          {
            var _t = e.find(function (e) {
              return e.selected && e.value;
            }) || 0;

            return _t && _t.value;
          }

        case "object":
          return e.find(function (e) {
            return e.selected && 0 === e.value ? e : !!e.selected && e.value;
          });

        case "list":
          return e.map(function (e) {
            return e;
          });

        default:
          return "Items not found";
      }
    }

    function O() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var t = arguments.length > 1 ? arguments[1] : undefined;
      return t ? e : e.map(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          selected: !1
        });
      });
    }

    t.default = function (_ref18) {
      var _ref18$name = _ref18.name,
          e = _ref18$name === void 0 ? "optioner" : _ref18$name,
          t = _ref18.options,
          n = _ref18.value,
          a = _ref18.label,
          _ref18$multiple = _ref18.multiple,
          r = _ref18$multiple === void 0 ? !1 : _ref18$multiple,
          $ = _ref18.onChange,
          C = _ref18.customLabelComponent,
          _ref18$returnValue = _ref18.returnValue,
          E = _ref18$returnValue === void 0 ? "single" : _ref18$returnValue,
          _ref18$enableToggle = _ref18.enableToggle,
          k = _ref18$enableToggle === void 0 ? !1 : _ref18$enableToggle,
          N = _ref18.selectAll,
          _ = _ref18.errorMessage,
          _ref18$customInputHea = _ref18.customInputHeader,
          j = _ref18$customInputHea === void 0 ? null : _ref18$customInputHea,
          I = _ref18.blurOnBoxClicked,
          P = _ref18.showInputHeader,
          _ref18$onClickOutside = _ref18.onClickOutside,
          S = _ref18$onClickOutside === void 0 ? function () {} : _ref18$onClickOutside,
          _ref18$customOnClick = _ref18.customOnClick,
          w = _ref18$customOnClick === void 0 ? !1 : _ref18$customOnClick,
          M = _ref18.style,
          _ref18$theme = _ref18.theme,
          T = _ref18$theme === void 0 ? "Themeless" : _ref18$theme,
          _ref18$className = _ref18.className,
          q = _ref18$className === void 0 ? "" : _ref18$className,
          _ref18$labelClassName = _ref18.labelClassName,
          L = _ref18$labelClassName === void 0 ? "" : _ref18$labelClassName,
          _ref18$checkBoxClassN = _ref18.checkBoxClassName,
          F = _ref18$checkBoxClassN === void 0 ? "" : _ref18$checkBoxClassN,
          _ref18$boxClassName = _ref18.boxClassName,
          H = _ref18$boxClassName === void 0 ? "" : _ref18$boxClassName,
          _ref18$textContClassN = _ref18.textContClassName,
          A = _ref18$textContClassN === void 0 ? "" : _ref18$textContClassN,
          _ref18$textClassName = _ref18.textClassName,
          B = _ref18$textClassName === void 0 ? "" : _ref18$textClassName,
          _ref18$errorClassName = _ref18.errorClassName,
          z = _ref18$errorClassName === void 0 ? "" : _ref18$errorClassName,
          D = _ref18.disabled;

      var _o$useState = o.useState([]),
          _o$useState2 = _slicedToArray(_o$useState, 2),
          G = _o$useState2[0],
          J = _o$useState2[1],
          _o$useState3 = o.useState(!1),
          _o$useState4 = _slicedToArray(_o$useState3, 2),
          R = _o$useState4[0],
          V = _o$useState4[1],
          _o$useState5 = o.useState(),
          _o$useState6 = _slicedToArray(_o$useState5, 2),
          K = _o$useState6[0],
          Q = _o$useState6[1],
          _o$useState7 = o.useState(!1),
          _o$useState8 = _slicedToArray(_o$useState7, 2),
          U = _o$useState8[0],
          W = _o$useState8[1],
          X = o.useRef(),
          Y = function Y(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        if (e instanceof Array) {
          return O(t, r).map(function (t, n) {
            return "object" == typeof e[0] && e[n].selected || e.includes(t.value) ? _objectSpread(_objectSpread({}, t), {}, {
              selected: !0
            }) : t;
          });
        }

        var n = s.find(function (t) {
          return t.value == e;
        }, t),
            a = s.findIndex(function (t) {
          return t.value == e;
        }, t);

        if (Q(a), n) {
          var _e = O(t, r);

          if (!n.selected || k) {
            return function (e, t, n) {
              return s.map(s.when(s.propEq("value", n), s.assoc("selected", t)), e);
            }(_e, !n.selected, n.value);
          }
        }

        return t;
      };

      function Z(e) {
        var t = e.target.value,
            n = Y(t, G);
        J(_toConsumableArray(n)), $ && $(y(n, E, r));
      }

      var ee = function ee(e, t) {
        e.stopPropagation(), t && t.current && (U ? t.current.classList.remove("focused") : t.current.classList.add("focused")), W(!U);
      },
          te = o.useCallback(function (e, t) {
        e.stopPropagation(), t.current && (t.current.contains(e.target) || (t.current.classList.remove("focused"), W(!1), S()));
      }, [S]),
          ne = function ne(e) {
        var t = "";
        return t = e + 1 === G.length ? "end" : 0 === e ? "begin" : "middle", t;
      };

      o.useEffect(function () {
        return document.addEventListener("click", function (e) {
          return te(e, X);
        }), function () {
          return document.removeEventListener("click", function (e) {
            return te(e, X);
          });
        };
      }, [te]), o.useEffect(function () {
        N || R ? function () {
          var e = _toConsumableArray(G).map(function (e) {
            return _objectSpread(_objectSpread({}, e), {}, {
              selected: N
            });
          });

          J(_toConsumableArray(e)), $ && $(y(e, E, r));
        }() : V(!0);
      }, [N]), o.useEffect(function () {
        var e = Y(n, O(G));
        J(_toConsumableArray(e));
      }, [JSON.stringify(n)]), o.useEffect(function () {
        if (!N) {
          var _e2 = Y(n, t);

          J(_toConsumableArray(_e2));
        }
      }, [t]);
      var ae = G.length;
      return o.default.createElement(l.ThemeProvider, {
        theme: i.isObject(T) ? T : c.default[T]
      }, o.default.createElement(u, {
        "data-testid": "lego-optioner",
        className: "Optioner " + q,
        style: M,
        ref: X,
        totalItems: ae,
        selectedItemIndex: K,
        disabled: D
      }, a && o.default.createElement(h, {
        "data-testid": "lego-optioner-label",
        className: "Optioner-label " + L
      }, a), o.default.createElement(m, {
        "data-testid": "lego-optioner-content"
      }, j ? j({
        list: G,
        isFocused: U,
        handleFocus: ee
      }) : o.default.createElement(p, {
        "data-testid": "lego-optioner-header-display",
        className: "Optioner-header-display",
        onClick: function onClick(e) {
          return ee(e, X);
        },
        show: P
      }, G.map(function (e, t) {
        return e.selected && o.default.createElement("span", {
          key: t,
          "data-testid": "lego-optioner-header-label"
        }, e.label + ", ");
      })), o.default.createElement(f, {
        "data-testid": "lego-optioner-box-container",
        className: "Optioner-box-container"
      }, o.default.createElement(d, {
        "data-testid": "lego-optioner-checkbox-group",
        className: "Optioner-checkbox-group " + F
      }, G && G.map(function (t, n) {
        var a = t.selected,
            r = C;
        return o.default.createElement(b, {
          "data-testid": "lego-optioner-box",
          className: "Optioner-box ".concat(H, " ").concat(a ? "selected" : "", " ").concat(t.status ? t.status : "", " ").concat(ne(n)),
          selected: a,
          key: n
        }, o.default.createElement("input", {
          type: "checkbox",
          "data-testid": "lego-optioner-checkbox-input",
          onClick: function onClick(e) {
            return function (e, t) {
              e.stopPropagation(), I && ee(e, t);
            }(e, X);
          },
          name: e,
          value: t.value,
          checked: a,
          onChange: function onChange(e) {
            return w ? {} : Z(e);
          }
        }), r ? r({
          index: n,
          item: t,
          selected: a,
          onChange: w ? Z : {}
        }) : o.default.createElement(g, {
          "data-testid": "lego-optioner-text-container",
          className: "Optioner-text-container " + A
        }, o.default.createElement(x, {
          "data-testid": "lego-optioner-text",
          className: "Optioner-text " + B
        }, t.label)));
      }))), _ && o.default.createElement(v, {
        "data-testid": "lego-optioner-error",
        className: "Optioner-error " + z
      }, _))));
    };
  },
  66: function _(e, t) {
    e.exports = require("ramda");
  },
  67: function _(e, t) {
    e.exports = require("../../themes/Optioner.theme");
  }
});